import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-bottom: 1rem;
  position: absolute;
  top: 50%;
  right: -2rem;
  transform: translateY(-45%);
`;

export const ComponentWrapper = styled.div`
  margin: 0 0.5rem;
`;

export const ItemRow = styled.div`
  align-items: center;
  display: flex;
  padding: 0.25rem 0;
`;

export const ItemTitle = styled.div`
  font-size: 0.875rem;
  margin: 0;
  padding-right: 0.25rem;
`;

export const List = styled.div`
  margin-left: 106px;
  margin-bottom: 1rem;
`;

export const Relative = styled.div`
  position: relative;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled.p`
  font-size: 0.75rem;
  margin: 0;
  margin-bottom: 1rem;
`;
